import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Button, Container, Grid2 } from '@mui/material';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "./customerSurvey.css";
import Footer from './Footer';

const StyledRating = styled(Rating)(({ theme }) => ({
    '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,

    },
}));

const customIcons = {
    1: {
        icon: <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 65 }} />,
        label: 'Very Dissatisfied',
    },
    2: {
        icon: <SentimentDissatisfiedIcon color="error" sx={{ fontSize: 65 }} />,
        label: 'Dissatisfied',
    },
    3: {
        icon: <SentimentSatisfiedIcon color="warning" sx={{ fontSize: 65 }} />,
        label: 'Neutral',
    },
    4: {
        icon: <SentimentSatisfiedAltIcon color="success" sx={{ fontSize: 65 }} />,
        label: 'Satisfied',
    },
    5: {
        icon: <SentimentVerySatisfiedIcon color="success" sx={{ fontSize: 65 }} />,
        label: 'Very Satisfied',
    },
};

function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
};


function CustomerSurvey() {

    const [text, setText] = React.useState("");
    const [firstQ, setFirstQ] = React.useState(0);
    const [secondQ, setSecondQ] = React.useState(0);
    const [thirdQ, setThirdQ] = React.useState(0);
    const [fourthQ, setFourthQ] = React.useState(0);
    const [fifthQ, setFifthQ] = React.useState(0);
    const [ratingValue, setRatingValue] = React.useState(0);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [loading, setLoading] = React.useState();
    const [responseMessage, setResponseMessage] = React.useState();
    const [firstName, setFirstName] = React.useState();
    const [lastName, setLastName] = React.useState();
    const [email, setEmail] = React.useState();
    const [phoneNumber, setPhoneNumber] = React.useState();
    const [subject, setSubject] = React.useState();
    const [message, setMessage] = React.useState();
    const [company, setCompany] = React.useState();
    const [position, setPosition] = React.useState();


    const currentDate = new Date().toISOString();




    const handleSubmit = (event) => {
            navigate("/SuccessPage");
    };

    const handleChange = (event) => {
        setText(event.target.value);
    };

   

    const navigate = useNavigate();
    return (
        <div id='customer-survey'>
            <div id='fi-q'>
                <div className='left-side'>

                    <p className='content-1'>1. How was the event?</p>
                    <Rating
                        className='stars'
                        name="simple-controlled"
                        value={fifthQ}
                        onChange={(event, newValue) => {
                            setFifthQ(newValue);
                        }}
                        sx={{
                            // Change the color of filled stars
                            '& .MuiRating-iconFilled': {
                                color: '#0066ff', // Custom color for filled stars
                            },
                            // Change the color of empty stars
                            '& .MuiRating-iconEmpty': {
                                color: '#0066ff', // Custom color for empty stars
                            },
                            // Change the color of hover stars
                            '& .MuiRating-iconHover': {
                                color: '#0066ff', // Custom color on hover
                            },
                            fontSize: 40
                        }}
                    />
                </div>
                <textarea cols="50" rows="2" type='text' onChange={handleChange}  placeholder='Please tell us how can we help?'
                    className='lg:py-4 lg:px-4  lg:w-[40rem] lg:h-[4rem]  outline-none' />
           
            </div>
            <Footer
                setFirstName = {setFirstName}
                setLastName = {setLastName}
                setEmail = {setEmail}
                setPhoneNumber = {setPhoneNumber}
                setSubject = {setSubject}
                setMessage = {setMessage}
                firstName = {firstName}
                email = {email}
                lastName = {lastName}
                phoneNumber = {phoneNumber}
                subject = {subject}
                text = {text}
                fifthQ = {fifthQ}
                message = {message}
                setPosition = {setPosition}
                setCompany = {setCompany}
                position = {position}
                company = {company}

            />
        </div>
    )
}

export default CustomerSurvey

